import {Box, Button, Text} from "grommet";
import {List} from "grommet-icons";
import React,{ useState } from "react";


const SideBarButton=(props)=>{
    const [isHovered, setIsHovered] = useState(false);
    const Icon = props?.icon
    return(
        <Button style={{
            width: !props?.smallSideBar ? '200px' : "50px",
            fontSize: '10px',
            //background: props?.pageName === props?.actualPage ? '#f8b20e' : '#FFFFFF',
            color: 'white',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            borderRadius: "20px",
            transition: 'background-color 0.2s ease',
            background: isHovered ? 'rgba(248, 178, 14,0.4)' : (props?.pageName === props?.actualPage ? '#f8b20e' : '#FFFFFF'),
            cursor: 'pointer' // Aggiungi il cursore a puntatore su hover
        }} 
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)} 
        onClick={() => {
            props?.setPage(props?.pageName)
        }}>
            <Box pad="10px" direction="row" align="center" gap="medium">
                {Icon && <Icon color={props?.pageName !== props?.actualPage ? 'black' : '#FFFFFF'}/>}
                {
                    !props?.smallSideBar &&
                    <Text size="xsmall" color={props?.pageName !== props?.actualPage  ? 'black' : '#FFFFFF'}>{props?.name}</Text>
                }
            </Box>
        </Button>
    )
}

export default SideBarButton;